import { Expose } from 'class-transformer'

export class BookCharacterRoleType {
  @Expose()
  id: number

  @Expose()
  name: string
}
